<script>
import AppForm from '../components/AppForm';
import getFieldErrors from '../getFieldErrors';
import AppButton from '../components/AppButton';
import ChallengeLoader from '../components/ChallengeLoader';

export default {
  name: 'SmartIdAuth',
  components: {
    AppForm,
    AppButton,
    ChallengeLoader,
  },
  data() {
    return {
      fieldErrors: {},
      challenge: undefined,
      authProcess: {},
    }
  },
  computed: {
    inputValues() {
      return this.$root.$options.storeGetters.inputValues();
    },
    additionalMethodConfig() {
      return this.$root.$options.storeGetters.additionalMethodConfig();
    },
    schema() {
      return  [
        {
          type: 'text',
          name: 'idcode',
          label: this.$t('idcode'),
          validation: ['required'],
        },
        {
          type: 'submit',
          label: this.$t('log-in')
        }
      ]
    },
    formValue: {
      get() {
        return {
          idcode:  this.inputValues.idcode,
        }
      },
      set(newValues){
        this.updateInputValues(newValues);
      }
    },
  },
  beforeDestroy() {
    this.cancel();
  },
  methods: {
    updateInputValues(newValues) {
      this.$root.$options.storeActions.updateInputValues(newValues);
    },
    loadingStart() {
      this.$root.$options.storeActions.loadingStart();
    },
    loadingEnd() {
      this.$root.$options.storeActions.loadingEnd();
    },
    addFlashMessage(message) {
      this.$root.$options.storeActions.addFlashMessage(message);
    },
    clearFlashMessages() {
      this.$root.$options.storeActions.clearFlashMessages();
    },
    clearErrors() {
      this.fieldErrors = {};
    },
    cancel() {
      const {cancel} = this.authProcess;
      if (cancel) {
        cancel();
      }
    },
    authenticate() {
      this.loadingStart();
      this.clearFlashMessages();
      this.clearErrors();
      const additionalMethodConfig = this.additionalMethodConfig || {};
      this.authProcess = this.$root.$options.eidEasyClient.identification.smartId.start({
        ...this.formValue,
        started: (result) => {
          if (result.data && result.data.challenge) {
            this.challenge = result.data.challenge;
            this.loadingEnd();
          }
        },
        fail: (error) => {
          if (!error.isCancel) {
            this.addFlashMessage(error);
          }
          this.fieldErrors = getFieldErrors(error);
          this.$root.$options.eidEasyOnFail(error);
        },
        success: (result) => {
          this.$root.$options.eidEasyOnSuccess(result);
        },
        finished: () => {
          this.challenge = undefined;
          this.loadingEnd();
        },
        ...additionalMethodConfig,
      });
    }
  },
}
</script>

<template>
  <div :class="$style.formContainer">
    <div
      v-if="challenge"
      :class="$style.challenge"
    >
      <ChallengeLoader :challenge="challenge" />
      <AppButton
        scheme="secondary"
        :on-click="() => cancel()"
      >
        {{ $t('cancel') }}
      </AppButton>
    </div>
    <div v-else>
      <AppForm
        id="smartIdForm"
        v-model="formValue"
        :schema="schema"
        :on-submit="authenticate"
        :errors="fieldErrors"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
.formContainer {
  max-width: $form-container-width;
  margin: 0 auto;
}
</style>
